import gql from 'graphql-tag';

export default gql`
  mutation DesyncEmail($accountId: ID!, $email: String!) {
    desyncEmail(accountId: $accountId, email: $email) {
      success
    }
  }
`;
